<div class="modal-body">
	<p> {{'shared_components.inactivity_dialog.body' | translate}} <span class="time-in-mins">{{ timer }}</span> {{'shared_components.inactivity_dialog.body2' | translate}} </p>
	<p>{{'shared_components.inactivity_dialog.body3' | translate}}</p>
</div>

<div class="modal-footer">
	<button pButton pRipple type="button" [label]="'buttons.continue' | translate" class="p-button-primary mr-2" (click)="closeDialog(true)"></button>
	<button pButton pRipple type="button" [label]="'buttons.logout' | translate" class="p-button-danger" (click)="closeDialog(false)"></button>
</div>
